import React, { useState } from "react";

import TimeAgo from 'timeago-react';
import makeStyles from '@mui/styles/makeStyles';
import { Grid, Typography } from "@mui/material";
import createStyles from '@mui/styles/createStyles';
import { useDispatch, useSelector } from "react-redux";

import { WEB_URL } from "../api/URLs";
import { MessageToDonor, WarningModal } from "./modals";
import { alertActions, fundRaiserPageAction } from "../store/actions";
import { donationConstants } from "../store/actionTypes";
import { Span, MixPanelTrackedLink, MuiAvatar as Avatar } from ".";
import { convertFirstLetterToUpperCase, currencyNeedsSpace } from "../helpers";
import { CLOSED_PAGE, DRAFT_PAGE, GTM_EVENTS, S3_BUCKET, TEAM_PAGE } from "../constants";
import { useNavigate } from "react-router-dom";

export function DonorCard(props) {
    const {
        isTeamDonor,
        data,
        pageDetails,
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const classes = useStyles();
    const totalRaised = !data.total_raised ? 0 : data.total_raised;
    const user = useSelector(state => state.authentication.user);
    const decreaseHeightWidth = { height: '30px', width: '30px' }; // For donar card in donation list
    const [removingInProgress, setRemovingInProgress] = useState(false);
    const [openWarningModal, setOpenWarningModal] = useState(false);
    const [openMessageModal, setOpenMessageModal] = useState(false);
    const [openRemoveMemberWarning, setOpenRemoveMemberWarning] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState({});

    let amountDigitsClass = "fuser-amount", amountText, listId = "";
    const leftSpace = currencyNeedsSpace(data.symbol_left) ? " " : "";

    if (isTeamDonor) {
        listId = 'div_' + data.id;
        amountDigitsClass = "fuser-amount-MD";
        amountText = `Raised ${data.symbol_left}${leftSpace}${(donationConstants.AMOUNT_FORMAT.includes(data.currency_code) ? totalRaised.toLocaleString('de-DE') : totalRaised.toLocaleString())} from ${data.total_donors} ${(data.total_donors > 1 ? 'donations' : 'donation')}`;
    }
    else {
        amountText = `${data.symbol_left}${leftSpace}${(donationConstants.AMOUNT_FORMAT.includes(data.currency_code) ? totalRaised.toLocaleString('de-DE') : totalRaised.toLocaleString())}`
    }

    const renderDonorName = () => {
        {/*
            isTeamDonor identifies if the donor is a part of page team or not
            because team donors are displayed in different component separate
            from normal donors
         */}
        if (!isTeamDonor && data.is_anonymous) {
            return 'Anonymous'
        }
        else return convertFirstLetterToUpperCase(data.first_name) + " " + convertFirstLetterToUpperCase(data.last_name)
    }

    const renderProfileImage = () => {
        {/*
            For the users who donated anonymously,
            the profile icon's background must be grey
            and for those who didn't donate anonymously
            and have no profile image either, the profile 
            icon's background must be orange
         */}
        if (!isTeamDonor && data.is_anonymous) {
            return <Avatar className='grey-bg'>
                <i className="icon-tcf-user-icon"></i>
            </Avatar>
        }

        else return <Avatar className='orange-bg' src={S3_BUCKET + data.profile_image}>
            <i className="icon-tcf-user-icon"></i>
        </Avatar>
    }

    const removeMember = async () => {
        let payload = {
            id: selectedRecord,
            fd_id: pageDetails.id
        };
        setRemovingInProgress(true);
        await dispatch(fundRaiserPageAction.removeTeamMember(payload));
        setRemovingInProgress(false);
        setOpenRemoveMemberWarning(false);
    }

    const copyToClipboard = (id, firstName, lastName) => {

        id = id + '_' + firstName + '_' + lastName;
        id = encodeURI(id.toLowerCase());
        let textField = document.createElement('textarea');
        textField.innerText = process.env.REACT_APP_URL + WEB_URL.FUNDRAISER_CHECKOUT(pageDetails.event_id) + "?cntry=" + pageDetails.country_id + "&crncy=" + pageDetails.currency_id + '&mmbr=' + id;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
        dispatch(alertActions.success("Member Link copied to clipboard"))
    }

    const generatePageRedirectLink = () => {
        let id = data.id + '_' + data.first_name + '_' + data.last_name;
        id = encodeURI(id.toLowerCase());
        const url = WEB_URL.FUNDRAISER_CHECKOUT(pageDetails.event_id) + "?cntry=" + pageDetails.country_id + "&crncy=" + pageDetails.currency_id + '&mmbr=' + id;
        navigate(url);
    }

    const handleDonateClick = () => {
        pageDetails.status == DRAFT_PAGE ?
            setOpenWarningModal(true) :
            generatePageRedirectLink()
    }

    const pageOpenedByThePageOwner = () => {
        return user.id == pageDetails.user_id
    }

    const isTeamPage = () => {
        return pageDetails.page_type == TEAM_PAGE
    }

    const getDonateContext = () => {
        return pageDetails.status == DRAFT_PAGE ?
            `Tried donating to ${data.first_name} ${data.last_name} but the page was draft` :
            `Donating to ${data.first_name} ${data.last_name}`
    }

    const handleRemoveClick = (data) => {
        setSelectedRecord(data.id)
        setOpenRemoveMemberWarning(true)
    }

    return (
        <div className="donation-listing-box organizer-listing-box">
            <div className="bottom-listing-box">
                <ul className="listing-box-outer-area">
                    <li id={listId}>
                        <div className="listing-box-outer">
                            <div className="fuser-image-box" style={!isTeamDonor ? decreaseHeightWidth : {}}>
                                {renderProfileImage()}
                            </div>
                            <div className="fuser-info-box">
                                <Typography>{renderDonorName()}</Typography>
                                {isTeamDonor && <Span className="fuser-type">{(data.is_leader === 1 ? 'Owner' : 'Team member')}</Span>}
                                <Span className="fuser-don-amount">
                                    <Span className={amountDigitsClass}>{amountText}</Span>
                                    {!isTeamDonor && <Span className="ftime">
                                        <TimeAgo datetime={data.transaction_date + ".558Z"} locale='en' />
                                    </Span>}
                                </Span>

                                {isTeamDonor &&
                                    <Grid container className={classes.buttonsContainer}>
                                        {/* 
                                            Donate button will only display iff 
                                            the donor is a page's team member and
                                            the page is still active 
                                        */}
                                        {
                                            pageDetails.status !== CLOSED_PAGE &&
                                            <Grid item>
                                                <MixPanelTrackedLink
                                                    size="small"
                                                    variant="outlined"
                                                    type="button"
                                                    label='Donate'
                                                    context={getDonateContext()}
                                                    className={classes.buttonHeight}
                                                    onClick={handleDonateClick}
                                                    gtmProps={{
                                                        fundrasier_name: pageDetails.page_title,
                                                        raised_amount: pageDetails.total_fund_raised,
                                                        number_of_donation: pageDetails.count_donations,
                                                        goal_amount: pageDetails.fundraising_goal
                                                    }}
                                                    gtmEvent={GTM_EVENTS.DONATE_NOW_CLICKED}
                                                >
                                                    Donate
                                                </MixPanelTrackedLink>
                                            </Grid>
                                        }
                                        {pageDetails.status !== DRAFT_PAGE &&
                                            <Grid item>
                                                <MixPanelTrackedLink
                                                    type="button"
                                                    size="small"
                                                    variant="outlined"
                                                    label="Copy link"
                                                    context={!data.is_leader ? "Copying team member link" : "Copying team owner link"}
                                                    className={classes.buttonHeight}
                                                    onClick={() => { copyToClipboard(data.id, data.first_name, data.last_name) }}
                                                >
                                                    Copy link
                                                </MixPanelTrackedLink>
                                            </Grid>}
                                    </Grid>
                                }
                            </div>
                            {/*
                                The dotted button will display iff
                                the donor is a team member (that gives the 
                                option of 'copy' or 'remove')
                                OR the page is opened by the page owner
                                (that gives the option for 'Message to donor')
                            */}
                            {(pageOpenedByThePageOwner()) && !data.is_leader &&
                                <div className="btn-group dropleft">
                                    <button type="button" className="btn-dotted clickmdf" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <Span className="dotted"></Span>
                                        <Span className="dotted"></Span>
                                        <Span className="dotted"></Span>
                                    </button>
                                    {!isTeamDonor ?
                                        <div className="dropdown-menu lnglabel">
                                            <ul>
                                                <li>
                                                    {/* This link will only appear if the page is opened by the page owner */}
                                                    <MixPanelTrackedLink
                                                        type="button"
                                                        label="Message to Donor"
                                                        context="Message to Donor"
                                                        onClick={() => setOpenMessageModal(true)}>
                                                        <i className="icon-tcf-heart"></i>
                                                        <Span>Message to Donor</Span>
                                                    </MixPanelTrackedLink>
                                                </li>
                                            </ul>
                                        </div>
                                        : <div className="dropdown-menu copyLabel">
                                            <ul>
                                                {/* 
                                        pageOpenedByThePageOwner identifies if the page is opened by owner
                                        because only the owner have the right to remove someone from the team
                                        */}
                                                {data.is_leader != 1 && pageOpenedByThePageOwner() && isTeamPage() &&
                                                    <li>
                                                        <MixPanelTrackedLink
                                                            type="button"
                                                            label="Team member remove"
                                                            context="Team member remove"
                                                            onClick={() => handleRemoveClick(data)}>
                                                            <i className="icon-tcf-quit"></i>
                                                            <Span>Remove</Span>
                                                        </MixPanelTrackedLink>
                                                    </li>
                                                }
                                            </ul>
                                        </div>}
                                </div>
                            }
                        </div>
                    </li>
                    <WarningModal open={openWarningModal} setOpen={setOpenWarningModal} message={"Please publish the page to accept donations"} />
                    <WarningModal
                        open={openRemoveMemberWarning}
                        setOpen={setOpenRemoveMemberWarning}
                        message="Are you sure you want to delete the team member"
                        firstButton={{
                            label: "Yes",
                            onClick: removeMember,
                            loading: removingInProgress
                        }}
                        secondButton={{
                            label: "No",
                        }}
                    />
                    <MessageToDonor open={openMessageModal} setOpen={setOpenMessageModal} donor={data} />
                </ul></div>
        </div>
    )
}
const useStyles = makeStyles(() =>
    createStyles({
        buttonHeight: {
            height: '25px !important'
        },
        buttonsContainer: {
            gap: '10px',
            marginTop: '10px'
        }
    }),
);